import { Keyboard } from '@capacitor/keyboard';
import { useEffect } from 'react';

/**
 * This hook will scroll to the input element that has focus when the keyboard opens.
 * It will only scroll if the element is an input, textarea or select.
 */
export const useScrollToInputWhenKeyboardOpens = () => {
  useEffect(() => {
    const listener = Keyboard.addListener('keyboardDidShow', () => {
      // Check if there's an input element focussed. If so, scroll to it.
      const element = document.activeElement;

      if (
        element instanceof HTMLInputElement ||
        element instanceof HTMLTextAreaElement ||
        element instanceof HTMLSelectElement
      ) {
        // We use a tiny timeout to ensure the scrollable area has adjusted in height before we scroll to it.
        // Not perfect, but works 99% of the time.
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'center' });
        }, 100);

        return;
      }
    });

    return () => {
      listener.then((subscription) => subscription.remove());
    };
  }, []);
};
